import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// The moderation queue for contested gig reviews.
//
// Contesting a review (jobs-api GigReviewController::flag) records the dispute
// and queues it — it deliberately does NOT hide the review or move the
// professional's rating, because the person asking is the one the review
// criticises. This screen is the other half: the only path in the application
// that can take a review out of the public record.
//
// 'remove' hides it and recalculates the rating; 'dismiss' leaves it exactly
// as it is and closes the contest so the same review cannot be disputed in a
// loop.
export const gigReviewContestsList = (params = '') => Http.get(`/admin/gigs/reviews/contested${serialize(params)}`)
export const gigReviewModerate = (id, data) => Http.post(`/admin/gigs/reviews/${id}/moderate`, data)
